import { defineStore } from "pinia"
import fetchWP from '@/utils/fetchWP'
import axios from 'axios'
import { Device } from '@twilio/voice-sdk'
import { useUserStore } from '../stores/user'
import Vue from 'vue'
// import * as VideoProcessors from '@twilio/video-processors';
// import { connect, createLocalVideoTrack } from 'twilio-video';
// import { VirtualBackgroundProcessor, GaussianBlurBackgroundProcessor } from '@twilio/video-processors';
// import { VideoRoomMonitor } from '@twilio/video-room-monitor';

// using eval to bypass compile warning/errors
const req = new fetchWP({
    restURL: eval('lead_dialer_vars.api.url'),
    restNonce: eval('lead_dialer_vars.api.nonce')
})

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            user: null,
            new_lead_dialog: {
                show: false,
                tab: 0
            },
            snackbar: {
                settings: {
                    show: false,
                    timeout: -1,
                    centered: false,
                    color: "primary",
                }
            },
            show_login_dialog: false,
            api: {
                url: eval('lead_dialer_vars.api.url'),
                restNonce: eval('lead_dialer_vars.api.nonce')
            },
            req,
            is_logging_in: false,
            show_login_error: false,
            show_app_overlay: false,
            app_overlay_text: "",
            ajaxurl: eval('lead_dialer_vars.ajaxurl'),
            current_to_phone_number: "",
            phone_number_input: "",
            placeholder_img: eval('lead_dialer_vars.api.placeholder_img'),
            assets_folder_url: eval('lead_dialer_vars.api.assets_folder'),
            room_id: eval('lead_dialer_vars.room_id'),
            unread_messages: {},
            contacts_unread_messages: {},
            contacts_table_key: 123,
            bottom_height: 0,
            top_height: 65,
            tasks: [],
            twilioVoiceToken: null,
            device: null,
            in_call: false,
            call: {
                parameters: {
                    CallSid: null
                },
                isMuted: () => false
            },
            outbound_call_sid: null,
            calls: {},
            current_lead: null,
            pusher: null,
            site: {},
            twilioMeetingToken: null,
            room_name: null,
            gaussianBlurProcessor: null,
            virtualBackgroundProcessor: null,
            videoTrack: null,
            rooms: [],
            room: {
                settings: {
                    header_logo: ''
                }
            },
            // selected_room: {},
            theme_loaded: false,
            show100ms: true,
            webhooks: []
        }
    },
    actions: {
        // show100ms() {
        //     let show = this.site?.domain_settings?.settings?.domain.meta?.override_user_100ms_settings[0] != '1'
        //     if(!this.site?.domain_settings)
        //         show = false
        //     console.log("show100ms", show)
        //     return show
        // },
        showCallInfo() {
            console.log("call info:", this.call)
            console.log("device info:", this.device)
        },
        showError(message, timeout = -1, click = null) {
            this.snackbar.settings = {
                color: "error",
                show: true,
                centered: false,
                top: true,
                message,
                timeout,
                click
            }
        },
        showSuccess: function(message, timeout = -1, click = null) {
            console.log("showSuccess", message)
            this.snackbar.settings = {
                color: "success",
                show: true,
                top: true,
                centered: false,
                message,
                timeout,
                click
            }
        },
        showNotification: function(message, timeout = 5, click = null) {
            this.snackbar.settings = {
                show: true,
                top: true,
                centered: true,
                right: false,
                multiline: true,
                message,
                timeout,
                click
            }
        },
        get: function(endpoint, data = false) {
            return this.request(endpoint, data, 'get')
        },
        post: function(endpoint, data = false) {
            return this.request(endpoint, data, 'post')
        },
        delete: function(endpoint, data = false) {
            return this.request(endpoint, data, 'delete')
        },
        request: function(endpoint, data, type) {
            let url = this.api.url + endpoint

            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-WP-Nonce': this.api.restNonce,
                'Outseta-Token': localStorage.getItem('Outseta.nocode.accessToken'),
            }

            if(data !== false)
                return axios[type](url, data, {
                    headers
                })
            return axios[type](url, {
                headers
            })
        },
        getSiteSettings: function($vuetify) {
            // console.log('getSiteSettings')
            // console.trace()
            this.get('site_settings')
            .then(response => {
                this.site = response.data

                if(response.data.domain_settings.settings.header_logo) {
                    console.log("domain settings", response.data.domain_settings)
                    this.room.settings.header_logo = response.data.domain_settings.settings.header_logo
                    this.room.settings.header_color = response.data.domain_settings.settings.header_color
                    this.room.settings.background_color = response.data.domain_settings.settings.background_color
                    this.room.settings.primary_color = response.data.domain_settings.settings.primary_color
                    this.room.settings.secondary_color = response.data.domain_settings.settings.secondary_color
                    this.room.settings.accent_color = response.data.domain_settings.settings.accent_color
                    this.room.settings.dark = response.data.domain_settings.settings.dark
                    this.setUpTheme($vuetify)
                } else {
                    console.log("no domain settings", response.data)
                }
                
                this.show100ms = this.site?.domain_settings?.settings?.domain.meta?.override_user_100ms_settings[0] != '1' ? true : false
            })
        },
        logOut: function() {
            this.show_app_overlay = true
            this.app_overlay_text = "Logging Out"
            this.get('user/logout')
            .then(response => {
                this.checkLoginStatus()
                window.location.reload()
                // this.user = null
                // this.user.userdata = {}
            })
        },
        checkLoginStatus: function() {
            console.log('checkLoginStatus')
            this.get('user/check_login')
                    .then(response => {
                        if(!response.data.logged_in) {
                            this.show_login_dialog = true
                        }
                        this.show_app_overlay = false
                    })
                    .catch(error => {
                        this.show_login_dialog = true
                        this.show_app_overlay = false
                        // window.location = "/wp-login.php?redirect_to="+escape(window.location.href)
                        this.redirectToLoginUrl()
                    })
        },
        doLogin: function(email, password) {
            this.is_logging_in = true
            this.show_login_error = false

            var data = new FormData();
            data.append("email", email);
            data.append("password", password);

            this.show_app_overlay = true
            this.app_overlay_text = "Logging In"
            this.show_login_dialog = false

            axios.post('/wp-admin/admin-ajax.php?action=dialer_login', data)
                .then(response => {
                    this.is_logging_in = false
                    if(response.data.login.ID > 0) {
                        window.location.reload()
                    } else {
                        this.is_logging_in = false
                        this.show_app_overlay = false
                        this.show_login_dialog = true
                        this.show_login_error = true
                    }
                })
                .catch(error => {
                    this.is_logging_in = false
                    this.show_app_overlay = false
                    this.show_login_dialog = true
                })
        },
        checkOutseta: function() {
            let user = useUserStore()
            let token = localStorage.getItem('Outseta.nocode.accessToken')
            if(!user?.userdata?.data?.ID && token){
                this.post('user/outseta/login', {token})
                .then(response => {
                    console.log("outseta login:", response.data)
                    if(response.data?.refresh == '1')
                        window.location.reload()
                })
                .catch(error => {
                    console.error(error)
                })

            }
        },
        createInterval: function() {
            var g = this
            this.check_login_interval = setInterval(function() {
                g.checkLoginStatus()
            }, 60000)
        },
        phoneNumberFormat: function(phone_number) {
            if(phone_number == undefined)
                return ""
                
            if(phone_number[0] == "+")
                phone_number = phone_number.substr(1)
            if(phone_number[0] == "1")
                phone_number = phone_number.substr(1)

            return '(' + phone_number.substr(0,3) + ') ' + phone_number.substr(3,3) + "-" + phone_number.substr(6,4)
        },
        playNotification: function(type = 'message') {
            const urls = {
                'message': this.assets_folder_url+"audio/elegant-notification-sound.mp3",
                'PEER_JOINED': this.assets_folder_url+"audio/alert.mp3",
                'PEER_JOINED': this.assets_folder_url+"audio/pop.mp3",
                'PEER_LEFT': this.assets_folder_url+"audio/pop.mp3",
                'ROLE_UPDATED': this.assets_folder_url+"audio/pop.mp3",
                'waiting_room': this.assets_folder_url+"audio/doorbell.mp3",
            }
            const audio = new Audio(urls[type]);
            audio.volume = 0.15
            audio.play();
        },
        getUnreadMessages: function() {
            this.get('lists/unread_messages')
            .then(response => {
                this.unread_messages = {}
                this.contacts_unread_messages = {}
                // this.contact_unread_messages = response.data.contacts
                // this.unread_messages = response.data
                response.data.lists.map(msg => {

                    //create a blank object if it doesn't exist yet
                    if(!this.unread_messages[msg.post_parent])
                        this.unread_messages[msg.post_parent] = {}

                    //add a object with the key of the post_title which is message sid
                    msg.message = JSON.parse(msg.post_content)
                    this.unread_messages[msg.post_parent][msg.post_title] = msg

                })

                response.data.contacts.map(msg => {
                    //create first/blank object array?
                    if(!this.contacts_unread_messages[msg.contact_id])
                        this.contacts_unread_messages[msg.contact_id] = []
                    if(!this.contacts_unread_messages[msg.contact_id].includes(msg.message_sid))
                        this.contacts_unread_messages[msg.contact_id].push(msg.message_sid)
                })

                this.contacts_table_key = Math.floor(Math.random()*10000)
            })
        },
        getTasks() {
            this.get('lists/tasks')
            .then(response => {
                this.tasks = response.data
            })
        },
        getTwilioToken: function () {
            this.user = useUserStore()
            var g = this
            g.get('token').then(data => {
                g.twilioVoiceToken = data.data.token
                
                if(g.device === null) {
                    g.device = new Device(g.twilioVoiceToken)
                    
                    //tokenWillExpire Event
                    g.device.on('tokenWillExpire', () => {
                        g.getTwilioToken()
                    });

                    // ERROR event
                    g.device.on('error', (twilioError, call) => {
                        // if(twilioError.indexOf('AccessTokenExpired') != -1)
                        //     g.getTwilioToken()
                        // else
                        //     g.hangUp()
                    });

                } else {
                    g.device.updateToken(data.token);
                }
            })
        },
        make_call: async function (params) {
            
            if (this.in_call || this.call.parameters.CallSid) {
                // add call to current conference/device

                return
            }

            //old token for testing : eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0

            let g = this
            this.in_call = true
            try {
                // this.app.device = new Device(this.app.twilioVoiceToken)
                let call_params = {
                    To: params.to,
                    callerId: this.user.current_phone_number.phone_number,
                    voicemail: params && params.voicemail ? 1 : 0,
                    user_id: this.user.userdata.ID,
                    contact_id: params.contact_id ?? 0
                }
                this.call = await this.device.connect({params: call_params})
            } catch (error) {
                console.error(error)
            }

            this.call.on('disconnect', connection => {
                this.in_call = false
                this.call = {
                    parameters: {
                        CallSid: null
                    }
                }
            })

            this.call.on("accept", () => {
                let g = this

                //wait 1 second to allow time for first call to drop in case of a direct to vm dial
                //the back end will also wait if needed, allowing time for the first vm dial to timeout
                // setTimeout(function() {
                    this.get(`outbound_call_sid/${g.call.parameters.CallSid}`).then(data => {
                        g.outbound_call_sid = data.data.CallSid
                    })
                // }, 1000)
            });


        },
        transfer_call: function () {
            this.get(`transfer/${this.outbound_call_sid}`).then(data => console.log(data))
        },
        hangUp: function () {
            this.device.disconnectAll()
            this.in_call = false
        },
        callIsActive: function () {
            return this.call.parameters.CallSid !== null
        },
        sendDigits: function (digit) {
            if (this.callIsActive)
                this.call.sendDigits(digit)
        },
        updateCallStatus: function(status) {
            console.log('call_status:', status.CallStatus, status)
            if(this.calls[status.CallSid])
                this.calls[status.CallSid] = {...this.calls[status.CallSid], ...status}
            else
                this.calls[status.CallSid] = status

            let phone_number = this.calls[status.CallSid].Called
            if(!this.calls[phone_number])
                Vue.set(this.calls, phone_number, {})
            if(this.calls[status.CallSid].CallStatus == 'completed')
                Vue.set(this.calls[phone_number], 'status_label', '')
            else
                Vue.set(this.calls[phone_number], 'status_label', `${this.calls[status.CallSid].CallStatus ?? ''} ${this.calls[status.CallSid].AnsweredBy ?? ''}`)
        },
        getCallStatusByPhoneNumber: function(phone_number) {
            let active_call = []
            for(const call in this.calls) {
                if(this.calls[call].Called == phone_number) {
                    active_call.push(this.calls[call])
                    return this.calls[call]
                }
            }
            return {}
        },
        phoneNumberStatus: function(phone_number) {
            return this.calls[`+1${phone_number}`] ? this.calls[`+1${phone_number}`].status_label : ''
        },
        phoneNumberStatusColor: function(phone_number) {
            let call = this.getCallStatusByPhoneNumber(`+1${phone_number}`)
            // console.log("app.phoneNumberStatusColor", phone_number, call)
            if(call.CallStatus == 'dialing') 
                return 'warning'
            if(call.CallStatus == 'ringing') 
                return 'warning'
            if(call.CallStatus == 'in-progress' && call.AnsweredBy == 'human') 
                return 'success'
            if(call.CallStatus == 'in-progress' && call.AnsweredBy != 'human') 
                return 'warning'
            return ''
        },
        formatDateUTC: function(date) {
            // return moment.utc(date).format('ddd, MMM D YYYY, h:mm a')
            var localTime  = moment.utc(date).toDate()
            // localTime = moment(localTime).format('YYYY-MM-DD h:mm a')
            localTime = moment(localTime).format('llll')
            return localTime
        },
        formatDate: function(date) {
            return moment(date).format('ddd, MMM D YYYY, h:mm a')
        },
        formatRelativeDate: function(date) {
            return moment(date).fromNow()
        },
        formatRelativeDateUTC: function(date) {
            var localTime  = moment.utc(date).toDate()
            localTime = moment(localTime).fromNow()
            return localTime                
            // return moment.utc(date).fromNow()
        },
        loadRooms: function() {
            this.loading_rooms = true
            this.get('meeting/rooms').then(response => {
                this.rooms = response.data.rooms
            })
            .catch(error => {
                console.error(error)
            })
            .finally(() => this.loading_rooms = false)
        },
        loadRoom: function($vuetify, $router, room_id = null) {
            let user = useUserStore()

            if(!room_id)
    			room_id = this.room_id > 0 ? this.room_id : false
            
            if(!room_id) {
                this.theme_loaded = true
                $router.push({name: 'Admin'})
                return
            }

            this.get(`site/room/${room_id}`).then(response => {
				this.room = response.data

				if(!this.room.settings && user.userdata.roles.length > 0) {
					this.theme_loaded = true
					$router.push({name: 'Admin'})
					return
				}
                this.setUpTheme($vuetify)
                this.theme_loaded = true
			})
		},
        setUpTheme: function($vuetify) {
			// // logo
			// this.app.site.logo_url = this.app.room.settings.header_logo
			// console.log("set site logo", this.app.site)
            // console.log("setUpTheme")
            // console.trace()

            if(!$vuetify)
                return

            console.log(this.room.settings)

			// dark mode
			$vuetify.theme.dark = this.room.settings.dark

            // header
            $vuetify.theme.themes.dark.header = this.room.settings.header_color.hex
            $vuetify.theme.themes.light.header = this.room.settings.header_color.hex
            
            // background
            $vuetify.theme.themes.dark.background = this.room.settings.background_color.hex
            $vuetify.theme.themes.light.background = this.room.settings.background_color.hex
            
            // primary
            $vuetify.theme.themes.dark.primary = this.room.settings.primary_color.hex
            $vuetify.theme.themes.light.primary = this.room.settings.primary_color.hex

            // secondary
            $vuetify.theme.themes.dark.secondary = this.room.settings.secondary_color.hex
            $vuetify.theme.themes.light.secondary = this.room.settings.secondary_color.hex
            
            // accent
            $vuetify.theme.themes.dark.accent = this.room.settings.accent_color.hex
            $vuetify.theme.themes.light.accent = this.room.settings.accent_color.hex

        },
        colorLightOrDark: function(color) {
            // Variables for red, green, blue values
            var r, g, b, hsp;
            
            // Check the format of the color, HEX or RGB?
            if (color.match(/^rgb/)) {
        
                // If RGB --> store the red, green, blue values in separate variables
                color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
                
                r = color[1];
                g = color[2];
                b = color[3];
            } 
            else {
                
                // If hex --> Convert it to RGB: http://gist.github.com/983661
                color = +("0x" + color.slice(1).replace( 
                color.length < 5 && /./g, '$&$&'));
        
                r = color >> 16;
                g = color >> 8 & 255;
                b = color & 255;
            }
            
            // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
            hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
            );
        
            // Using the HSP value, determine whether the color is light or dark
            if (hsp>127.5) {
                return 'light';
            } 
            else {
                return 'dark';
            }
        },
        headerIsDark: function() {
            let is_dark = this.colorLightOrDark(this.room.settings.header_color.hex) == 'dark'
            return is_dark
        },
        primaryIsDark: function() {
            let is_dark = this.colorLightOrDark(this.room.settings.primary_color.hex) == 'dark'
            return is_dark
        },
        redirectToLoginUrl() {
            let url = this.site?.domain_settings?.settings?.domain.meta?.login_url[0] ?? '/login/'
            console.log("redirect to url:", url)
            window.location.href = url
        },
        getWebhooks() {
            this.get('meeting/webhooks')
            .then(response => {
                this.webhooks = response.data.webhooks
            })
        }
    }
})